import { Schema as S } from "effect";
import { defineTaggedUnion } from "foldkit/schema";

/** Minimal current-user projection (KTD3). Never Clerk's full `User`, never a token. */
export const User = S.Struct({
	id: S.String,
	organizationId: S.optionalKey(S.String),
	name: S.String,
	email: S.String,
	isAdmin: S.Boolean,
	/** Clerk `user.createdAt` as ISO, kept a string so `Equal.equals` stays structural. */
	createdAt: S.NullOr(S.String),
});
export type User = typeof User.Type;

export const Auth = defineTaggedUnion({
	ClerkLoading: {},
	SignedOut: {},
	SignedIn: { user: User },
});
export type Auth = typeof Auth.Type;
